<template>
  <div data-v-e5781868="" class="container mainContent noMargin top50" style="background: #fafafa;">
				<div class="banner">
					<div class="section section1"></div>
				</div>
				<div class="navigation">
					<ul style="display: flex;">
						<li class="active"><a title="试玩体验 开户入门"> 试玩 / 开户 </a></li>
						<li class=""><a title="资金交易 发财致富"> 存款 / 取款 </a></li>
						<li class=""><a title="信息设置 安全无忧"> 修改资料 </a></li>
						<li class=""><a title="优惠订阅 致富无忧"> 其他自助服务 </a></li>
					</ul>
				</div>
				<div class="title">试玩体验 开户入门</div>
				<div class="bottom"> 
					<div class="guide" style="display: block;">
						<div class="flex-start item-container">
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/free-play.b342fbcb.png">
								<div class="flex-start row"> 免费试玩 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/signup.67c78670.png">
								<div class="flex-start row"> 极速开户 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/mobile.5dd13824.png">
								<div class="flex-start row"> 手机开户 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
						</div>
						
					</div>
					
					<div class="guide" style="display: none;">
						<div class="t">如何取款</div>
						<div class="flex-start item-container">
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/rmb-withdraw@3x.png_.6b342429.webp">
								<div class="flex-start row"> 人民币取款 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/sell.png_.322edb0a.webp">
								<div class="flex-start row"> 卖币变现 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
								<div class="flex-center flag">数字货币</div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/withdraw-wallet.png_.5bb0f54b.webp">
								<div class="flex-start row"> 提币至钱包 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
								<div class="flex-center flag">数字货币</div>
							</div>
						</div>
						<div class="t">如何存款</div>
						<div class="flex-start item-container">
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/bank-card-deposit.21df1c3f.png">
								<div class="flex-start row"> 银行卡充值 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/other-deposit.b056f7b1.png">
								<div class="flex-start row"> 其他方式充值 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/bg.d03f7283.png">
								<div class="flex-start row"> USDT钱包充币 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
								<div class="flex-center flag">数字货币</div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/rmb-deposit.7c1407b4.png">
								<div class="flex-start row"> 人民币购买USDT <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
						</div>
						<div class="flex-start item-container" style="margin-top: -40px;">
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/gin.41b4c331.png">
								<div class="flex-start row"> 小金库充币 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
								<div class="flex-center flag">数字货币</div>
							</div>
						</div>
					</div>
					
					<div class="guide" style="display: none;">
						<div class="flex-start item-container">
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/update-mobile.6689f02c.png">
								<div class="flex-start row"> 修改手机号 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/add-bank-card.4ca9a3ff.png">
								<div class="flex-start row"> 添加银行卡 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/update-password.15073b3a.png">
								<div class="flex-start row"> 修改密码 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/update-limit.cff3d2bf.png">
								<div class="flex-start row"> 修改限红 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
						</div>
					</div>
					
					<div class="guide" style="display: none;">
						<div class="flex-start item-container">
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/washcode.55bd3909.png">
								<div class="flex-start row"> 结算洗码 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/balance.ae49eacb.png">
								<div class="flex-start row"> 余额查询 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
							<div class="item" data-url="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><img src="/static/image/transaction.62c20a30.png">
								<div class="flex-start row"> 交易记录查询 <svg data-v-338e1447="" aria-hidden="true" class="svg-icon video-play">
									<use data-v-338e1447="" xlink:href="#icon-video-play"></use>
									</svg></div>
							</div>
						</div>
					</div>
					<div data-v-538eb7ef="" class="backdrop backdrop2" style="display: none;" id="videoBox"><div data-v-538eb7ef="" class="videoPopUp"><svg data-v-338e1447="" data-v-538eb7ef="" aria-hidden="true" class="svg-icon videoClose"><use data-v-338e1447="" xlink:href="#icon-videoClose"></use></svg><div data-v-538eb7ef="" class="video"><video id="video" data-v-538eb7ef="" controls="" width="100%" height="100%" src="https://hwvod.yzbabyu.com:8443/vod-play/91a2c0/01-demoaccount.mp4"><source data-v-538eb7ef="" muted="muted" autoplay="autoplay" controls="controls" src="" type="video/mp4"></video></div></div></div>
				</div>
			</div>
</template>
<script>
export default {
  name: 'aboutUS',
  data() {
    return {};
  },
  created() {
    let that = this;
  },
  methods: {
    loginBox() {
      console.log($('.mask'));
      $('.mask').fadeOut(300);
      $('.mask.login').fadeIn(300);
    },
    registerBox() {
      $('.mask').fadeOut(300);
      $('.mask.register').fadeIn(300);
    },
    forgetBox() {
      $('.mask').fadeOut(300);
      $('.mask.forget').fadeIn(300);
    },
  },
  mounted() {
    let that = this;
   $(window).scroll(function () {
			if ($(document).scrollTop() <= $('.topicTopBar').height()) {
				$('.topicTopBar').show();
			} else {
				$('.topicTopBar').hide();
			}
		});
		$('.navigation ul li').click(function () {
			var text = $(this).find('a').attr('title');
			$('.navigation').next('.title').text(text);
			var index = $(this).index();
			$('.bottom .guide').eq(index).slideDown(300).siblings().slideUp(0);
			$(this).addClass('active').siblings().removeClass('active');
			$('html,body').animate({ scrollTop: $('.navigation').offset().top }, 500);
		});

		$('.item-container .item').click(function () {
			var videoUrl = $(this).attr('data-url');
			$('#video').attr('src', videoUrl);
			$('#videoBox').fadeIn(500);
		});
		$('.videoClose').click(function () {
			$('#videoBox').fadeOut(0);
		});
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../../static/css/chunk-3230c737.5b7eef8e.css';
@import '../../../static/css/chunk-009dfcc3.a4bf2976.css';
@import '../../../static/css/chunk-1225a5b6.b06a16a7.css';

 .faq .faq-container .row .group .a-row[data-v-3ecdc100] {
          display: none;
        }
	

.container .item-container .item .row[data-v-2f128f92]{
	background: #fafafa;
	border: 1px solid #ccc;
	border-radius: 10px;
	color: #000;
}

</style>



// WEBPACK FOOTER //
// src/components/allMode/guides.vue